import React from 'react';
import { useFormContext } from 'react-hook-form';
import TimeField from 'react-simple-timefield';
import cx from 'classnames';

import FieldWrapper from './FieldWrapper';

import { shrink } from '../styles.module.css';

const DurationInput = (props) => {
  const { register } = useFormContext();
  const {
    id,
    required = false,
    type = 'text',
    validation,
    className,
    title,
    disabled,
  } = props;

  return (
    <FieldWrapper {...props}>
      <TimeField
        showSeconds
        input={
          <input
            size="8"
            disabled={disabled}
            name={id}
            id={id}
            className={cx(className, shrink)}
            ref={register({
              required: required && `${title} required`,
              ...validation,
            })}
            {...{ type }}
          />
        }
      />
    </FieldWrapper>
  );
};

export default DurationInput;
